import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { loadFirebase } from 'lib/firebase/lazy'
import Loading from 'lib/components/Loading'

import Recall from './Recall'

const ClientRecall = () => {
  const router = useRouter()
  const apiId = router.query.apiId

  const [data, setData] = useState(undefined)
  const [loading, setLoading] = useState(Boolean(apiId))

  useEffect(() => {
    if (!apiId) {
      return
    }
    let cancelled = false
    setLoading(true)
    loadFirebase()
      .then(app => app.firestore().doc(`recalls/${apiId}`).get())
      .then(snap => {
        if (cancelled) return
        setData(snap.exists ? snap.data() : null)
        setLoading(false)
      })
      .catch(() => {
        if (cancelled) return
        setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [apiId])

  if (loading) {
    return <Loading />
  }

  return <Recall recall={data} />
}

const Loader = ({ recall }) => {
  if (recall) {
    return <Recall recall={recall} />
  }

  return <ClientRecall />
}

Loader.getInitialProps = async ({ query, req }) => {
  if (!process.browser) {
    const startedAt = Date.now()
    const rawId = query.apiId == null ? '' : String(query.apiId)
    const apiId = /^[A-Za-z0-9._-]{1,80}$/.test(rawId) ? rawId : 'invalid'

    const logFetch = (fields, isError) => {
      try {
        const { logger } = eval("require('firebase-functions/logger')")
        const payload = {
          event: 'ssr.recall.fetch',
          requestId: (req && req.ssrRequestId) || null,
          apiId,
          firestoreMs: fields.firestoreMs,
          exists: fields.exists,
          outcome: fields.outcome,
        }
        if (fields.errorName) {
          payload.errorName = fields.errorName
        }
        if (isError) {
          logger.error('ssr.recall.fetch', payload)
        } else {
          logger.info('ssr.recall.fetch', payload)
        }
      } catch (ignore) {
        // Telemetry must not change SSR behavior.
      }
    }

    try {
      const admin = eval("require('firebase-admin')")
      const snap = await admin.firestore().doc(`recalls/${query.apiId}`).get()

      const firestoreMs = Date.now() - startedAt
      const exists = snap.exists
      const outcome = exists ? 'ok' : 'missing'

      if (req) {
        req.ssrFirestoreMs = firestoreMs
        req.ssrOutcome = outcome
      }

      logFetch({ firestoreMs, exists, outcome }, false)

      return {
        recall: snap.data(),
      }
    } catch (err) {
      const firestoreMs = Date.now() - startedAt

      if (req) {
        req.ssrFirestoreMs = firestoreMs
        req.ssrOutcome = 'error'
      }

      logFetch(
        {
          firestoreMs,
          exists: false,
          outcome: 'error',
          errorName: err && err.name ? err.name : 'Error',
        },
        true,
      )

      try {
        eval("require('@sentry/node')").captureException(err, {
          tags: { event: 'ssr.recall.fetch' },
          extra: { apiId },
        })
      } catch (ignore) {
        // Error reporting must not change SSR behavior.
      }

      throw err
    }
  }

  return {}
}

export default Loader
